<template>
    <a-drawer class="preview-box" :closable="false" @close="close" :visible.sync="visible" width="503px">
        <div class="wrapper">
            
            <div class="header">

                <div class="info-box" v-if="detail.member">
                    <div class="avatar">
                        <img :src="detail.member.avatar">
                    </div>
                    <div class="info">
                        <div class="name">{{ detail.member.mark_name || detail.member.name }}</div>
                        <div class="id-row">
                            <div class="id">ID：{{ detail.member.member_id }}</div>
                            <div class="time">{{ formattedTime }}</div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="line"></div>

            <div class="content">

                <div class="title">{{ detail.title }}</div>
                <div class="summary">{{ detail.summary }}</div>

                <div class="qa-box">
                    <div class="qa-item" v-for="(item,index) in detail.questions" :key="item.id">
                        <!-- 序号 -->
                        <div class="qa-title">
                            <span class="required" v-if="item.required">*</span>
                            <span class="no">{{ index+1 }}.</span>
                            <span>{{ item.title }}</span>
                        </div>

                        <div class="text-box" v-if="item.type == 'text'">
                            <div class="qa-text">{{ item.answers.answer }}</div>
                            <div class="images" v-if="item.answers.images && item.answers.images.length > 0">
                                <img v-for="(img,imgIdx) in item.answers.images" :key="imgIdx" :src="img" @click="previewImage(img)">
                            </div>
                        </div>
                        
                        <template v-else>
                            <div class="qa-options">
                                <!-- item.answers.option_ids 是用户选择的选项id数组，根据这个数组判断是否选中 -->
                                <div class="qa-option" :class="{'qa-option-active': item.answers.option_ids.includes(option.id)}" 
                                v-for="(option,subIdx) in item.options" :key="option.id">
                                    <div class="checkbox"></div>
                                    <div class="sort">{{ String.fromCharCode(65+subIdx) }}：</div>
                                    <div class="content">{{ option.title }}</div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <template v-if="showPreviewModal">
            
            <a-modal class="img-modal" :closable="false" v-model="showPreviewModal" :footer="null">
                <img @click="showPreviewModal = false" :src="previewImageUrl" />
            </a-modal>
            
        </template>
    </a-drawer>

    
</template>

<script>
import api from '@/repo/api';
import moment from 'moment';
export default {
    name: 'MemberDetail',
    data() {
        return {
            visible: false,
            detail: {},
            previewImageUrl: '',
            showPreviewModal: false,
        }
    },
    mounted() {

    },
    computed: {
        formattedTime() {
            if (this.detail.created_at) {
                return moment(this.detail.created_at).format('YYYY-MM-DD HH:mm:ss');
            }
            return '';
        }
    },
    methods: {
        previewImage(url) {
            this.previewImageUrl = url;
            this.showPreviewModal = true;
        },
        getDetail(id,am_id) {
            this.$loading.show();
            api.get('/ast-qa/member-detail', { id,am_id }, res => {
                if (res.code == 0) {
                    this.detail = res.data || {};
                    this.visible = true;
                }
                this.$loading.hide();
                this.$forceUpdate()
            })
        },
        close() {
            this.visible = false;
        }
    }
}
</script>

<style lang="scss" scoped>
.preview-box {
    /deep/ .ant-drawer-body {
        padding: 0;
    }
}

.img-modal {
    display: flex;
    align-items: center;
    justify-content: center;
    /deep/ .ant-modal {
        top: 0;
        // min-width: 60vw !important;
        max-width: 80vw !important;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    /deep/ .ant-modal-content {
        width: 100%;
    }

    /deep/ .ant-modal-body {
        img{
            width: 100% !important;
        }
    }
}

.wrapper{
    padding: 32px;
}

.header {

    .info-box {
        width: 100%;
        height: 48px;
        display: flex;
        align-items: center;
        margin-bottom: 24px;
        .avatar {
            width: 48px;
            height: 48px;
            border-radius: 50%;
            margin-right: 8px;
            img {
                width: 48px;
                height: 48px;
                border-radius: 50%;
            }
        }
        .info{
            width: 100%;
            height: 48px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            div {
                color: #606266;
                font-size: 14px;
                line-height: 20px;
            }
            .id-row {
                display: flex;
                align-items: center;
                justify-content: space-between;
            }
        }
    }
}

.line {
    width: 100%;
    height: 1px;
    background-color: #EEEEEE;
    margin-top: 8px;
    margin-bottom: 32px;
}

.content {
    .title {
        color: #333333;
        font-size: 20px;
        font-weight: bold;
        text-align: center;
    }
    .summary {
        color: #999999;
        font-size: 14px;
        margin-top: 24px;
    }
    .qa-box {
        margin-top: 40px;
        padding-bottom: 100px;
        .qa-item {
            margin-bottom: 24px;

            .qa-title {
                font-size: 14px;
                color: #333333;
                line-height: 20px;
                .required {
                    color: #FF2323;
                    margin-right: 2px;
                }
                .no {
                    margin-right: 8px;
                }
            }

            .text-box{
                width: 396px;
                border: 1px solid #D9D9D9;
                padding: 12px;
                box-sizing: border-box;
                margin-top: 16px;
                margin-left: 28px;

                .qa-text {
                    color: #333333;
                    font-size: 12px;
                    line-height: 17px;
                }

                .images {
                    margin-top: 8px;
                    img {
                        width: 80px;
                        height: 80px;
                        margin-right: 16px;
                        margin-top: 16px;
                        object-fit: cover;
                        &:nth-child(4n) {
                            margin-right: 0;
                        }
                    }
                }
            }
            

            .qa-options {
                .qa-option {
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    margin-top: 16px;
                    .checkbox {
                        width: 16px;
                        height: 16px;
                        border-radius: 2px;
                        border: 1px solid #D9D9D9;
                        margin-right: 4px;
                    }
                    .sort {
                        color: #333333;
                        font-size: 14px;
                    }
                    .content {
                        color: #333333;
                        font-size: 14px;
                    }
                }

                .qa-option-active{
                    .checkbox{
                        border: none;
                        background-image: url('/assets/images/question-active.png');
                        background-size: cover;
                    }
                }
            }
        }
    }
}
</style>
